import { createAction, props } from "@ngrx/store";
import { Office } from "../models/office.interface";
import { Producer } from "../models/producer.model";

// Office
export const loadCompanyOffices = createAction(
  "[Shared Component] Load company offices"
);

export const companyOfficesLoaded = createAction(
  "[Shared Component] Company offices loaded",
  props<{ data: Office[] }>()
);

// Producer
export const loadProducerList = createAction(
  "[Shared Component] Load producer list"
);

export const producerListLoaded = createAction(
  "[Shared Component] Producer list loaded",
  props<{ data: Producer[] }>()
);

export const forceReloadproducerList = createAction(
  "[Shared Component] Force reload Producer list"
);


// Product Types
export const loadProductTypes = createAction(
  "[Reference Store] Load Product Types"
);

export const productTypesLoaded = createAction(
  "[Reference Store] Load Product Types loaded",
  props<{ data: string[] }>()
);
